import { JBButton } from '@jbhi-fi/lanyard-ui';
import React from 'react';
import { createPortal } from 'react-dom';

export type InjectedCustomLinkProps = {
  linkTitle: string;
  elementId: string;
  clickEvent: () => void;
};

export const InjectedCustomLink = ({ linkTitle, elementId, clickEvent }: InjectedCustomLinkProps) => {
  const exDisplayLink = document.getElementById(elementId);
  if (!exDisplayLink) return null;

  return createPortal(
    <JBButton type="link" onClick={clickEvent}>
      {linkTitle}
    </JBButton>,
    exDisplayLink
  );
};
